import { render, staticRenderFns } from "./PkgProductItem.vue?vue&type=template&id=42ca721a&scoped=true&"
import script from "./PkgProductItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./PkgProductItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PkgProductItem.vue?vue&type=style&index=0&id=42ca721a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca721a",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
